import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import { type Search } from "./types";

export const localStateSelector = makeModuleStateSelector<Search.AppState>(defaultState, previewState);
